import { render, staticRenderFns } from "./MfcProfileDropper.vue?vue&type=template&id=147f5f68&scoped=true&"
import script from "./MfcProfileDropper.vue?vue&type=script&lang=js&"
export * from "./MfcProfileDropper.vue?vue&type=script&lang=js&"
import style0 from "./MfcProfileDropper.vue?vue&type=style&index=0&id=147f5f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f5f68",
  null
  
)

export default component.exports